export enum WHATSAPP_TAGS {
  NORMAL = "normal",
  CAMPAIGN = "campaign",
  EVENT = "event",
  CAMPAIGN_DETAIL = "campaign-detail",
  EVENT_DETAIL = "event-detail",
  DISCOUNT = "discount",
  WORKER = "trainer",
  ADD_VENUE = "add-venue",
  ADD_COMPANY = "add-company",
  ADD_COMPANY_IN_VENUE_DETAIL = "add-company-in-venue-detail",
  COMPANY_DISCOUNT_INFO = "company-discount-info",
  COMPANY_DISCOUNT_INFO_IN_VENUE_DETAIL = "company-discount-info-in-venue-detail",
  COMPANY_DISCOUNT_NOT_RECEIVED = "company-discount-not-received"
}

export enum WHATSAPP_SECTIONS {
  VENUE_CARD = 'venue_card',
  VENUE_CONTACT_MODAL = 'venue_contact',
  DISCOUNT = 'discount',
  CAMPAIGN = 'campaign',
  EVENT = 'event',
  VENUE_DETAIL = 'venue_detail',
  TRAINER = 'trainer',
}
